import FileMetaDTO from "@/dto/files/FileMetaDTO";
import SignableDocumentDTO from "@/dto/files/SignableDocumentDTO";
import PersonDTO from "@/dto/person/PersonDTO";
import { MelioStatus } from "@/dto/company/MelioStatus";
import {ProfileStatus} from "@/dto/common/ProfileStatus";

export default class CompanyDetailsDTO {
    public id: number | null = null;

    public name: string | null = null;

    public ein: string | null = null;

    public einVerificationProof: FileMetaDTO | null = null;

    public einVerificationDate: Date | null = null;

    public dba: string | null = null;

    public nationalTin: string | null = null;

    public website: string | null = null;

    public phone: string | null = null;

    public federalTaxClass: string | null = null;

    public certificateOfIncorporation: FileMetaDTO | null = null;

    public filingReceipt: FileMetaDTO | null = null;

    public naicsCode: number | null = null;

    public reserveAgreement: SignableDocumentDTO | null = null;

    public melioLink: string | null = null;

    public melioStatus: MelioStatus | null = null;

    public status: ProfileStatus | null = null;

    public booksProLink: string | null = null;

    public officer: PersonDTO | null = null;

    public bsoId: string | null = null;
}

export enum CompanyDocumentType {
    FORM_SS4 = 'FORM_SS4',
    CERTIFICATE_OF_INCORPORATION = 'CERTIFICATE_OF_INCORPORATION',
    FILING_RECEIPT = 'FILING_RECEIPT',
    GOVERNING_AGREEMENT = 'GOVERNING_AGREEMENT',
    ORGANIZATIONAL_MINUTES_OR_WRITTEN_CONSENT = 'ORGANIZATIONAL_MINUTES_OR_WRITTEN_CONSENT',
    ANNUAL_MEETING_MINUTES_OR_ANNUAL_WRITTEN_CONSENT = 'ANNUAL_MEETING_MINUTES_OR_ANNUAL_WRITTEN_CONSENT',
    RESOLUTIONS_REGISTER = 'RESOLUTIONS_REGISTER',
    OWNERSHIP_REGISTER_AND_TRANSFER_LEDGER = 'OWNERSHIP_REGISTER_AND_TRANSFER_LEDGER',
    CAPITAL_CONTRIBUTION_AGREEMENTS_AND_COMMITMENT_SCHEDULE = 'CAPITAL_CONTRIBUTION_AGREEMENTS_AND_COMMITMENT_SCHEDULE',
    SHAREHOLDER_AGREEMENT = 'SHAREHOLDER_AGREEMENT',
    BUY_SELL_AGREEMENT_AND_VALUATION_METHODOLOGY = 'BUY_SELL_AGREEMENT_AND_VALUATION_METHODOLOGY',
    SINGLE_CLASS_OF_STOCK_CERTIFICATION = 'SINGLE_CLASS_OF_STOCK_CERTIFICATION',
    ADMISSION_AND_WITHDRAWAL_CONSENTS = 'ADMISSION_AND_WITHDRAWAL_CONSENTS',
    OFFICER_OR_MANAGER_AUTHORITY_SCHEDULE = 'OFFICER_OR_MANAGER_AUTHORITY_SCHEDULE',
    BANKING_RESOLUTION_AND_SIGNATURE_AUTHORITY = 'BANKING_RESOLUTION_AND_SIGNATURE_AUTHORITY',
    PARTNERSHIP_REPRESENTATIVE_DESIGNATION = 'PARTNERSHIP_REPRESENTATIVE_DESIGNATION',
    PASS_THROUGH_ENTITY_TAX_ELECTION_AUTHORIZATION_NEW_YORK = 'PASS_THROUGH_ENTITY_TAX_ELECTION_AUTHORIZATION_NEW_YORK',
    WRITTEN_INFORMATION_SECURITY_PROGRAM = 'WRITTEN_INFORMATION_SECURITY_PROGRAM',
    EMPLOYEE_HANDBOOK_WITH_NEW_YORK_REQUIRED_POLICIES = 'EMPLOYEE_HANDBOOK_WITH_NEW_YORK_REQUIRED_POLICIES',
    CONFLICT_OF_INTEREST_POLICY_AND_ANNUAL_DISCLOSURES = 'CONFLICT_OF_INTEREST_POLICY_AND_ANNUAL_DISCLOSURES',
    RECORDS_RETENTION_AND_DESTRUCTION_POLICY = 'RECORDS_RETENTION_AND_DESTRUCTION_POLICY',
    SEPARATION_OF_FUNDS_STATEMENT = 'SEPARATION_OF_FUNDS_STATEMENT',
    SUCCESSOR_DESIGNATION_OR_TRANSFER_ON_DEATH_PROVISION = 'SUCCESSOR_DESIGNATION_OR_TRANSFER_ON_DEATH_PROVISION',
}

export interface CompanyDocument {
    id: number;
    companyId: number;
    companyName: string;
    type: CompanyDocumentType;
    document: FileMetaDTO;
    comment?: string | null;
}

export interface CompanyDocumentsSettings {
    companyId: number;
    typesDisplaySettings: CompanyDocumentType[];
}

export interface CompanyDocumentUploadItem {
    type: CompanyDocumentType;
    file: FileMetaDTO | null;
    comment?: string | null;
}

export class CompanyDocumentsDTO {
    documents: Partial<Record<CompanyDocumentType, FileMetaDTO | null>> = {};
    documentIds: Partial<Record<CompanyDocumentType, number | null>> = {};

    public bsoId: string | null = null;

    constructor(init?: Partial<CompanyDocumentsDTO>) {
        Object.assign(this, init)
        if (init?.documents) {
            this.documents = { ...init.documents };
        }
        if (init?.documentIds) {
            this.documentIds = { ...init.documentIds };
        }
    }
}

export class UploadCompanyDocumentsPayload {
    companyId: number | null = null
    documents: CompanyDocumentUploadItem[] = []

    constructor(init?: Partial<UploadCompanyDocumentsPayload>) {
        Object.assign(this, init)
    }
}
